<template>
  <v-content class="grey lighten-4">
    <AppBar title="Schema">
      <v-btn tile icon @click="refresh" :loading="loading">
        <v-icon dark>mdi-refresh</v-icon>
      </v-btn>
    </AppBar>
    <AppNavigationDrawer />

    <v-container class="px-0">
      <transition name="scroll-y-transition" mode="out-in">
        <div v-if="loading" class="d-flex flex-column align-center pt-12">
          <v-progress-circular size="56" indeterminate color="primary" />
          <span class="mt-4 grey--text text--darken-1">Hämtar schema...</span>
        </div>
        <div v-else-if="data.length">
          <SchemaListItem :duty="duty" v-for="(duty, $i) of data" :key="$i" />
        </div>
        <div v-else class="d-flex flex-column align-center pt-12">
          <v-icon size="50">mdi-information-outline</v-icon>
          <span class="grey--text text--darken-1">Inget schema hittades</span>
        </div>
      </transition>
    </v-container>
  </v-content>
</template>

<script>
import AppBar from '@/components/AppBar'
import AppNavigationDrawer from '@/components/AppNavigationDrawer'
import SchemaListItem from '@/components/SchemaListItem'
import { queryDuty } from '@/api/queryDuty'
import { format, subDays } from 'date-fns'

export default {
  name: 'Schema',

  components: {
    AppBar,
    AppNavigationDrawer,
    SchemaListItem
  },

  data: () => ({
    loading: true,
    data: []
  }),

  created() {
    this.fetch()
  },

  computed: {
    employeeNumber() {
      return this.$store.get('sso/user').employeenumber
    }
  },

  methods: {
    async fetch() {
      this.loading = true

      const fromDate = format(subDays(new Date(), 7), 'yyyy-MM-dd')
      const query = {
        $orderby: 'DutyDate',
        $filter: `Employee/EmployeeNumber eq '${this.employeeNumber}' and DutyDate gt ${fromDate}`,
        $expand: 'Employee, Pieces($orderby=StartTime)',
        $select:
          'DistrictId, DutyDate, DutyName, DutyStart, DutyEnd, DutyAbsence, Pieces'
      }
      const data = await queryDuty(query)
      this.data = data

      this.loading = false

      this.$nextTick(() => {
        const el = this.$el.querySelector(
          `[data-date="${format(new Date(), 'yyyy-MM-dd')}"]`
        )

        const { top } = el.getBoundingClientRect()

        window.scrollTo({
          top: top - 130,
          behavior: 'smooth'
        })
      })
    },

    refresh() {
      this.fetch()
    }
  }
}
</script>
